export interface StatItem {
  value: string;
  label: string;
}

export interface Testimonial {
  name: string;
  role: string;
  quote: string;
}

export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export const site = {
  name: '职镜观察',
  nameEn: 'ZHIJING OBSERVE',
  tagline: '深挖平台内幕，还原真实职场',
  slogan: '在决定之前，先看清一家公司真实的样子',
  intro:
    '职镜观察是一个面向普通职场人的信息整理平台。我们把分散在各处的公开线索、员工叙述与制度文本重新梳理成可读的观察记录，覆盖运营内幕、管理层背景、员工爆料、办公环境、裁员动向与薪资纠纷等话题，帮助你在求职、在职和维权时都拥有更完整的判断依据。',
  email: 'tougao@zhijingguancha.cn',
  replyTime: '工作日 48 小时内回复',
  submitNote:
    '如果你愿意提供一线经历、内部流程细节或可查证的公开资料，欢迎通过投稿渠道联系我们。所有线索在发布前都会经过交叉核对，涉及个人隐私的信息会被脱敏处理。',
};

export const stats: StatItem[] = [
  { value: '1,280+', label: '已整理观察条目' },
  { value: '326', label: '覆盖企业与平台' },
  { value: '96%', label: '线索二次核实率' },
  { value: '14.6万', label: '月度阅读人次' },
];

export const principles: Principle[] = [
  {
    icon: 'ri-file-search-line',
    title: '公开信息优先',
    desc: '所有结论尽量建立在可查证的公开资料上，注明线索来源与核实时间，不做无根据的推测。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '隐私脱敏处理',
    desc: '投稿内容发布前会去除可识别个人身份的信息，仅保留与公共讨论相关的事实部分。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '给双方留出位置',
    desc: '争议性表述会同时呈现不同说法，并保留当事方回应的通道，避免单方面定性。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续跟进更新',
    desc: '企业情况会随时间变化，已发布的观察条目会根据新的公开信息标注更新与更正记录。',
  },
];

export const testimonials: Testimonial[] = [
  {
    name: '陈屿',
    role: '互联网运营 · 求职中',
    quote:
      '面试前把职镜上关于这家公司的观察条目翻了一遍，问的问题明显更有针对性，也避开了几家风评和实际落差很大的公司。',
  },
  {
    name: '林知夏',
    role: '人力资源从业者 · 上海',
    quote:
      '作为从业者，我最看重的是它不煽动情绪。裁员补偿那一组文章把 N、N+1 和协商解除讲得很清楚，比很多所谓科普靠谱。',
  },
  {
    name: '周慕',
    role: '应届毕业生 · 武汉',
    quote:
      '刚毕业不太懂试用期和绩效的规则，薪资纠纷栏目里的几篇帮我提前知道了要留哪些凭证，心里踏实很多。',
  },
  {
    name: '郑柏',
    role: '产品经理 · 深圳',
    quote:
      '办公环境那几篇写得很细，通勤、工位密度、会议噪声都提到了，这些细节招聘页面从来不会讲。',
  },
];